import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { CommonLayout } from '~/atomic/layout/CommonLayout';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { Contests } from '~/atomic/page/contest/Contests';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { createStore, RootState } from '~/store';

const ContestEverythingWillBeFinePage: NextPage & LayoutType = () => {
  const title = 'Список всех конкурсов';

  return (
    <PageTemplate
      isPublic={pagesConfigStore.contests.isPublic}
      seo={{
        title,
        canonical: pagesConfigStore.contests.url,
      }}
      content={(
        <Contests />
      )}
    />
  );
};

ContestEverythingWillBeFinePage.getLayout = (page) => (
  <CommonLayout>{ page }</CommonLayout>
);

export const getServerSideProps: GetServerSideProps<{ state: RootState; }> = async (ctx) => {
  const { store, dispatch } = await createStore();
  const isLoggedIn = await checkAuthToken(ctx, dispatch);

  const state = store.getState();

  return { props: { state } };
};

export default ContestEverythingWillBeFinePage;
